import { DEFAULT_PARAMS } from 'components/SearchSideBar/constants';
import {
  createConditionQueryObject,
  createQueryUrl,
} from 'components/SearchSideBar/logics/createSearchResultPageUrl';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { createUrl } from './createUrl';

/**
 * 選択された検索条件に基づいて検索結果ページに移動する関数
 *
 * @param {SelectedCurrentConditionType} selectedSearchCondition - 現在選択されている検索条件
 * @param {number} oldestDayWdtno - 最古のWdtnoの値
 * @returns {void}
 */
export const moveToSearchResultPage = (
  selectedSearchCondition: SelectedCurrentConditionType,
  oldestDayWdtno: number
) => {
  const searchConditionQuery = createQueryUrl(
    createConditionQueryObject({
      selectedCurrentCondition: selectedSearchCondition,
      oldestDayWdtno: oldestDayWdtno.toString(),
      defaultParams: DEFAULT_PARAMS,
    })
  );

  const url = createUrl(searchConditionQuery);

  window.location.href = url;
};
